/* Olfé kopmenu: openen en sluiten van de panelen op desktop (muis, aanraking, toetsenbord)
   en het uitklappen van rijen in het mobiele menu. Markup: snippets/olfe-nav-desktop.liquid
   en snippets/olfe-nav-mobile.liquid. */
(function () {
  'use strict';

  var CLOSE_DELAY = 140;
  var OPEN_DELAY = 70;

  function initNav(nav) {
    if (nav.onavReady) return;
    nav.onavReady = true;

    var header = nav.closest('.header');
    var items = Array.prototype.slice.call(nav.querySelectorAll('[data-onav-item]'));
    var openItem = null;
    var closeTimer = null;
    var openTimer = null;

    function trigger(item) { return item.querySelector('[data-onav-trigger]'); }

    function setOpen(item) {
      window.clearTimeout(closeTimer);
      window.clearTimeout(openTimer);
      if (openItem === item) return;
      if (openItem) {
        openItem.classList.remove('is-open');
        trigger(openItem).setAttribute('aria-expanded', 'false');
      }
      openItem = item;
      if (item) {
        item.classList.add('is-open');
        trigger(item).setAttribute('aria-expanded', 'true');
      }
      if (header) header.classList.toggle('onav-open', !!item);
    }

    function scheduleClose() {
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(function () { setOpen(null); }, CLOSE_DELAY);
    }

    items.forEach(function (item) {
      var button = trigger(item);
      var hasUrl = button.tagName === 'A';

      item.addEventListener('pointerenter', function (event) {
        if (event.pointerType !== 'mouse') return;
        window.clearTimeout(closeTimer);
        window.clearTimeout(openTimer);
        /* Is er al een paneel open, dan direct wisselen; anders een korte drempel tegen per ongeluk openen. */
        if (openItem) setOpen(item);
        else openTimer = window.setTimeout(function () { setOpen(item); }, OPEN_DELAY);
      });

      item.addEventListener('pointerleave', function (event) {
        if (event.pointerType !== 'mouse') return;
        scheduleClose();
      });

      button.addEventListener('click', function (event) {
        var touch = window.matchMedia('(hover: none)').matches;
        if (!hasUrl) {
          event.preventDefault();
          setOpen(openItem === item ? null : item);
        } else if (touch && openItem !== item) {
          /* Aanraakscherm: eerste tik opent het paneel, tweede tik volgt de link. */
          event.preventDefault();
          setOpen(item);
        }
      });

      /* Toetsenbord: een link met paneel opent bij focus (Enter volgt de link); een knop opent met Enter of spatie. */
      item.addEventListener('focusin', function (event) {
        if (hasUrl && event.target === button && button.matches(':focus-visible')) setOpen(item);
      });

      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget) && openItem === item) setOpen(null);
      });
    });

    /* Muis op een item zonder paneel: een open paneel van een ander item sluit. */
    Array.prototype.forEach.call(nav.children, function (li) {
      if (li.hasAttribute('data-onav-item')) return;
      li.addEventListener('pointerenter', function (event) {
        if (event.pointerType === 'mouse' && openItem) scheduleClose();
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !openItem) return;
      var button = trigger(openItem);
      setOpen(null);
      button.focus();
    });

    document.addEventListener('pointerdown', function (event) {
      if (openItem && !nav.contains(event.target)) setOpen(null);
    });

    /* De kop verdwijnt bij omlaag scrollen: het paneel gaat dan mee dicht. */
    window.addEventListener('scroll', function () {
      if (!openItem || !header) return;
      var section = header.closest('.shopify-section');
      if (section && section.classList.contains('header-hidden')) setOpen(null);
    }, { passive: true });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-onav]'), initNav);
  }

  /* Mobiel menu: rij met submenu uitklappen. Gedelegeerd, want het thema verplaatst de lade naar <body>. */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-omn-toggle]');
    if (!toggle) return;
    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;
    var open = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.classList.toggle('is-open', open);
    /* Na het uitklappen de onderste links in beeld brengen als ze onder de rand vallen. */
    if (open) {
      window.setTimeout(function () {
        if (panel.classList.contains('is-open')) panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }, 270);
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
